import { ExpandButton, FlexColumn, FullContainer, GenericComponent } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { ASIDE_WIDTH } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  aside: React.ReactNode;
  canHide: boolean;
  asideSize?: number;
};

export function AsideLayout({ aside, asideSize = ASIDE_WIDTH, canHide = false, children }: GenericComponent & Props) {
  const { css, theme } = useStyles();
  const [asideIsExpanded, setAsideIsExpanded] = useState(true);

  const getAsideWidth = (reduceBy: number) => {
    return `clamp(200px, 80%, ${asideSize - reduceBy}px)`;
  };

  const getAsideMargin = (reduceBy: number) => {
    return !asideIsExpanded ? `clamp(-${asideSize - reduceBy}px, -80%, -200px)` : 0;
  };

  return (
    <>
      <FullContainer
        flexible
        classNames={css({
          boxSizing: 'border-box',
          flexDirection: 'column',
          padding: theme.sizing.scale400,
          order: 1,
        })}
      >
        {children}
      </FullContainer>
      <FlexColumn
        classNames={css({
          minWidth: getAsideWidth(100),
          maxWidth: getAsideWidth(100),
          padding: theme.sizing.scale400,
          borderRight: `1px solid ${theme.colors.borderOpaque}`,
          position: 'relative',
          boxSizing: 'border-box',
          marginLeft: getAsideMargin(100),
          transition: 'margin-left 0.3s ease-in-out',
          order: 0,
          [theme.mediaQuery.large]: {
            minWidth: getAsideWidth(50),
            maxWidth: getAsideWidth(50),
            marginLeft: getAsideMargin(50),
          },
          [theme.mediaQuery.extraLarge]: {
            minWidth: getAsideWidth(0),
            maxWidth: getAsideWidth(0),
            marginLeft: getAsideMargin(0),
          },
        })}
      >
        {aside}
        {canHide && (
          <ExpandButton
            isExpanded={asideIsExpanded}
            onClick={() => {
              setAsideIsExpanded((prev) => !prev);
            }}
          />
        )}
      </FlexColumn>
    </>
  );
}
